import { Environment } from './environment.model';
import { VERSION } from './version';

export const environment: Environment = {
  production: false,
  envName: 'Homolog',
  version: VERSION + '-beta',
  apiBaseUrl: 'https://api.homolog.webdespachantes.com.br/v1/site',
  hotJarTrackingCode: null,
};
